import { ElementType } from 'react';
import { KnownDeliveryDtoDeliveryType } from '@groundfloor-platform/mgmt-service-g-sdk';
import { deliveryTypeToIconMap } from '../../../../../features/deliveries/maps/delivery-type-to-icon.map';

/** The module SVGs hardcode 34px; size them down to match the Material icons used by other rows. */
const ICON_SIZE = { width: 24, height: 24 };

/**
 * Module-type icon for a delivery/order result, keyed on the result's `subType` via the shared
 * delivery-type icon map. Order results can carry a *status* subType (orders with no delivery
 * yet) — anything outside the map renders the generic `Fallback` icon.
 */
export function DeliveryTypeIcon({ subType, Fallback }: { subType?: string; Fallback: ElementType }) {
  const Icon = subType ? deliveryTypeToIconMap[subType as KnownDeliveryDtoDeliveryType] : undefined;
  return Icon ? <Icon style={ICON_SIZE} /> : <Fallback />;
}
